<template>
  <div :style="( search == true) ? 'background-color : white':''">
    <template v-if="select_all == true">
      <button type="button" :disabled="disabled" @click="selected_all" class="btn btn-sm btn-primary mr-2">Pilih Semua</button>
      <button type="button" :disabled="disabled" @click="deselect_all" class="btn btn-sm btn-danger">Batal Pilih</button>
    </template>
    <v-select
      multiple="multiple"
      label="dd_o_label"
      :reduce="options => options.dd_o_value"
      :options="options"
      @input="send($event)"
      v-model="post"
      :disabled="disabled"
      :close-on-select="false"
    >
      <template #search="{attributes, events}" v-if="required == true">
        <input class="vs__search" :required="!post" v-bind="attributes" v-on="events" />
      </template>
    </v-select>
  </div>
</template>

<script>

export default {
  props: [
    "name",
    "validation",
    "content",
    "dropdown_name",
    "parsingTrigger",
    "parsingPostMulti",
    "search",
    "table_module",
    "select_all"
  ],
  data() {
    return {
      post: this.content,
      options: [],
    };
  },
  mounted() {
    if (this.disabled == false) 
    {
      this.getDropdownList();
    }
  },
  watch: {
    parsingTrigger(){
      this.getDropdownList();
      this.post = "";
      this.extra = [];
      this.$emit("post", {
        name: this.name,
        value: [],
      });
    }
  },
  computed: {
    required() {
      if (this.validation == "required") {
        return true;
      }

      return false;
    },
    totalPrice() {
      return 0;
    },
    valueCrsModel() {
      var res = "";
      if (typeof this.parsingPostMulti != "undefined") {
        if (
          this.parsingPostMulti.crs_model_id != "" &&
          this.parsingPostMulti.crs_model_id != undefined
        ) {
          res = this.parsingPostMulti.crs_model_id;
        }
      }
      return res;
    },
    valueCrsBrand() {
      var res = "";
      if (typeof this.parsingPostMulti !== "undefined") {
        if (typeof this.parsingPostMulti.crs_brand_id !== "undefined") {
          if (
            this.parsingPostMulti.crs_brand_id != "" &&
            this.parsingPostMulti.crs_brand_id != undefined &&
            this.parsingPostMulti.crs_brand_id != null 
          ) {
            res = this.parsingPostMulti.crs_brand_id;
          }
        }
      }
      return res;
    },

    disabled() {
      var res = false;
      if (this.table_module == 'services' || this.table_module == 'services_bulk')
      {
        if (this.name == 'crs_model_id')
        {
          if (typeof this.parsingPostMulti != "undefined") {
            if (
              this.parsingPostMulti.crs_brand_id != "" &&
              this.parsingPostMulti.crs_brand_id != undefined
            ) {
              res = false
            }
            else
            {
              res = true
            }
          }          
        }
      }
      return res;
    },
  },
  methods: {
    getDropdownList : function(){
      var params = {};
  
      if (this.dropdown_name == "srv_id") {

        if (this.valueCrsModel != "") {
          params["filter[crs_model_id]"] = this.valueCrsModel;
        }
      }
      else if (this.dropdown_name == "dd_crs_model"){
        if (this.valueCrsBrand != "") {
          params["filter[crs_brand_id]"] = this.valueCrsBrand;
        }
      }

      this.axios
        .get("/dropdown/list/" + this.dropdown_name, { params: params })
        .then((response) => {
          this.options = response.data.data;
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 500) {
              console.log("error 500");
            }
          }
        });  
    },
    send() {
      this.$emit("post", {
        name: this.name,
        value: this.post,
      });
    },
    selected_all(){
      this.post = []
      if (this.options.length > 0) 
      {
        this.options.forEach((element, key) => {
          this.$set(this.post, key, element.dd_o_value)
          // console.log(key, element.dd_o_value);
        }); 

        this.$emit("post", {
          name: this.name,
          value: this.post,
        });
      }
    },
    deselect_all(){
      this.post = [];

      this.$emit("post", {
        name: this.name,
        value: this.post,
      });
    }
  },
};
</script>